var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKling = function SvgKling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "Kling_svg__pointer-events-none Kling_svg__size-4 Kling_svg__select-none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Kling_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.706 6.888c.254-.776.589-1.523.999-2.228C5.29 1.914 7.602.282 8.87 1.013 6.019-.633 2.299.472.561 3.482c-.207.36-.381.737-.519 1.128-.129.37.046.767.385.963l2.279 1.314Z",
    fill: "url(#Kling_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.294 5.082a11.595 11.595 0 0 1-1 2.228c-1.585 2.746-3.897 4.378-5.165 3.647 2.852 1.646 6.572.54 8.31-2.47.207-.358.38-.736.518-1.127.13-.369-.046-.767-.385-.963L9.294 5.082Z",
    fill: "url(#Kling_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.295 7.31c1.585-2.746 1.843-5.565.575-6.297-1.267-.732-3.579.902-5.165 3.647 1.037-1.795 2.904-2.658 4.172-1.926 1.267.732 1.454 2.78.417 4.575l.001.001Z",
    fill: "url(#Kling_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.705 4.66c-1.585 2.746-1.843 5.565-.575 6.296 1.267.732 3.58-.9 5.165-3.646C7.258 9.104 5.39 9.966 4.123 9.236c-1.267-.732-1.454-2.78-.418-4.576Z",
    fill: "url(#Kling_svg__e)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Kling_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3.73886 -6.2551 8.57184 5.12364 2.586 6.819)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#FFF959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#0DF35E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0BF2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04A6F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Kling_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(120.868 3.245 5.245) scale(7.28735 9.9864)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#FFF959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#0DF35E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0BF2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04A6F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kling_svg__d",
    x1: 7.789,
    y1: 0.899,
    x2: 9.031,
    y2: 4.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BFFE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kling_svg__e",
    x1: 4.211,
    y1: 11.071,
    x2: 2.969,
    y2: 7.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BFFE7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Kling_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgKling;